module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.elements), function(item, index) {
    return _c('item', {
      key: index,
      attrs: {
        "item": item,
        "index": index,
        "previousItem": _vm.previousItem,
        "nextItem": _vm.nextItem
      },
      on: {
        "active": _vm.active
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1626bd28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Items.vue
// module id = 312
// module chunks = 0